/* wi-d2.js - Direction D scale-out port base behaviors, generated 2026-07-21 */
(function(){
  if(window.__wiD2Init) return;
  window.__wiD2Init = 1;

  /* Every behavior runs inside run() so one failure never breaks the others.
     Class-based queries are scoped to .wi-d2 (the section wrapper) so nothing
     touches the surrounding theme chrome; ID lookups are global and null-checked.
     Fold-only pages (hero/gallery/buybox only) hit early returns everywhere else. */
  function run(fn){ try{ fn(); }catch(e){ /* isolate this behavior */ } }

  function init(){
    run(anchorScroll);
    run(freshChip);
    run(sciAccordion);
    run(gallery);
    run(midScrollers);
    run(flips);
    run(baSliders);
    run(faqs);
    run(steppers);
    run(pdescClamp);
    run(stickyBar);
    run(stickySubmit);
    run(duoAdd);
    run(statBand);
    run(triptychCounter);
  }

  /* ---------- in-page anchor smooth scroll (settle-and-correct) ----------
     Below-fold images lazy-load DURING a long smooth scroll and push the layout
     down, so a single scrollIntoView lands short of the target. After the scroll
     settles we re-check the target position and correct, up to 3 times over ~2.5s,
     until the target sits at the top (respecting scroll-margin-top). Scoped to
     .wi-d2 links so theme-chrome anchors are left alone. */
  function anchorScroll(){
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('.wi-d2 a[href^="#"]');
      if(!a) return;
      var href = a.getAttribute('href');
      if(!href || href === '#') return;
      var t = document.getElementById(href.slice(1));
      if(!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior:'smooth', block:'start' });
      var corrections = 0, lastY = -1, settled = 0;
      var iv = setInterval(function(){
        var y = window.pageYOffset;
        if(Math.abs(y - lastY) < 2){ settled++; } else { settled = 0; }
        lastY = y;
        if(settled >= 3){ // scroll has stopped; is the target where it should be?
          var margin = 96;
          try{ margin = parseFloat(getComputedStyle(t).scrollMarginTop) || 96; }catch(_){ }
          var off = t.getBoundingClientRect().top - margin;
          if(Math.abs(off) > 12 && corrections < 3){
            corrections++;
            settled = 0;
            t.scrollIntoView({ behavior:'smooth', block:'start' });
          } else {
            clearInterval(iv);
          }
        }
      }, 120);
      setTimeout(function(){ clearInterval(iv); }, 4000);
    });
  }

  /* ---------- freshness chip (client-side batch-week date math) ----------
     Owner rule 2026-07-13: always show the COMPLETED batch week, i.e. the PREVIOUS
     Monday, rolling forward each Monday. On Mon Jul 13 the chip reads "Jul 6"; on
     Mon Jul 20 it becomes "Jul 13". Never names the current week. No holiday list
     in the base to extend; the Liquid also renders this label server-side. */
  function freshChip(){
    var el = document.getElementById('freshChipHero');
    if(!el) return;
    var now = new Date();
    var dow = (now.getDay() + 6) % 7;                                       // Mon=0 .. Sun=6
    var monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - dow - 7, 12); // previous Monday
    el.textContent = 'Bottled the week of ' + monday.toLocaleDateString('en-US', { month:'short', day:'numeric' });
  }

  /* ---------- science accordion auto-open ----------
     Anchors that target content inside the closed <details id="sciAcc"> open it
     first (capture phase, before the smooth scroll measures its height). Also
     opens on initial load when the URL hash points inside it. */
  function sciAccordion(){
    var acc = document.getElementById('sciAcc');
    if(!acc) return;
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if(!a) return;
      var id = (a.getAttribute('href') || '').slice(1);
      if(!id) return;
      var t = document.getElementById(id);
      if(t && acc.contains(t) && !acc.open){ acc.open = true; }
    }, true);
    if(location.hash){
      var t = document.getElementById(location.hash.slice(1));
      if(t && acc.contains(t)) acc.open = true;
    }
  }

  /* ---------- gallery ---------- */
  function gallery(){
    var track = document.getElementById('gTrack');
    if(!track) return;
    var thumbs = [].slice.call(document.querySelectorAll('.wi-d2 #gThumbs .thumb'));
    var counter = document.getElementById('gCounter');
    var n = thumbs.length, i = 0;
    if(!n) return;
    // go() offsets by +1 because a sentinel clone of the last slide is prepended (seamless wrap)
    function go(x){
      i = (x + n) % n;
      track.style.transform = 'translateX(-' + ((i + 1) * 100) + '%)';
      thumbs.forEach(function(t,k){ t.classList.toggle('active', k === i); });
      if(counter) counter.textContent = (i + 1) + ' / ' + n;
    }
    var next = document.querySelector('.wi-d2 .g-next'), prev = document.querySelector('.wi-d2 .g-prev');
    if(next) next.onclick = function(){ go(i + 1); };
    if(prev) prev.onclick = function(){ go(i - 1); };
    thumbs.forEach(function(t){ t.onclick = function(){ go(+t.dataset.i); }; });
    var x0 = null;
    track.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive:true });
    track.addEventListener('touchend', function(e){
      if(window.matchMedia('(max-width:700px)').matches) return;
      if(x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if(Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    });

    // Seamless wrap: sentinel clones at both ends. Strip [id] from clones (dup-id safety).
    // Real <img> src is carried by cloneNode(true), so no image re-sync is needed in the port.
    var reals0 = [].slice.call(track.children);
    var firstReal = reals0[0], lastReal = reals0[n - 1];
    if(!firstReal || !lastReal){ go(0); return; }
    var headClone = lastReal.cloneNode(true), tailClone = firstReal.cloneNode(true);
    headClone.className += ' g-clone'; tailClone.className += ' g-clone';
    [headClone, tailClone].forEach(function(c){
      [].slice.call(c.querySelectorAll('[id]')).forEach(function(e){ e.removeAttribute('id'); });
    });
    track.insertBefore(headClone, track.firstChild); track.appendChild(tailClone);
    go(0);

    // Mobile gallery dots: on <=700px the track is a native finger-scroll snap slider
    // (arrows/thumbs/counter hidden); dots show position and are tappable.
    var dots = document.createElement('div'); dots.className = 'g-dots';
    for(var k = 0; k < n; k++)(function(k){
      var d = document.createElement('button'); d.type = 'button';
      d.className = 'g-dot' + (k === 0 ? ' on' : '');
      d.setAttribute('aria-label', 'Go to slide ' + (k + 1));
      d.addEventListener('click', function(){
        var s = track.children[k + 1];
        if(s) s.scrollIntoView({ behavior:'smooth', inline:'center', block:'nearest' });
      });
      dots.appendChild(d);
    })(k);
    var frost = document.querySelector('.wi-d2 .frost-frame');
    if(frost) frost.after(dots);

    var mqM = window.matchMedia('(max-width:700px)');
    function pitch(){ var s = track.children[1]; return s ? (s.getBoundingClientRect().width + 10) : 1; }
    function idxAll(){ return Math.round(track.scrollLeft / pitch()); }
    if(mqM.matches) requestAnimationFrame(function(){
      if(track.children[1]) track.children[1].scrollIntoView({ behavior:'instant', inline:'center', block:'nearest' });
    });
    track.addEventListener('scroll', function(){
      var real = (((idxAll() - 1) % n) + n) % n;
      for(var j = 0; j < n; j++){ if(dots.children[j]) dots.children[j].classList.toggle('on', j === real); }
    }, { passive:true });
    track.addEventListener('scrollend', function(){
      var a = idxAll();
      if(a <= 0){ if(track.children[n]) track.children[n].scrollIntoView({ behavior:'instant', inline:'center', block:'nearest' }); }
      else if(a >= n + 1){ if(track.children[1]) track.children[1].scrollIntoView({ behavior:'instant', inline:'center', block:'nearest' }); }
    });
  }

  /* ---------- mid-page mobile snap scrollers (seamless wrap, mobile only) ----------
     Covers the B/A wall, actives flip grid, and the review/quote scroller. Horizontal
     track.scrollTo ONLY, never scrollIntoView: these sections sit mid-page and
     scrollIntoView would scroll the page vertically. Clones only visible items so
     desktop-hidden cards are excluded off-mobile and included on. */
  function midScrollers(){
    if(!window.matchMedia('(max-width:700px)').matches) return;
    ['.ba-wall', '.flip-grid', '.best-rev-grid'].forEach(function(sel){
      var track = document.querySelector('.wi-d2 ' + sel);
      if(!track) return;
      var items = [].slice.call(track.children).filter(function(c){ return getComputedStyle(c).display !== 'none'; });
      var n = items.length;
      if(n < 2) return;
      var head = items[n - 1].cloneNode(true), tail = items[0].cloneNode(true);
      head.className += ' m-clone'; tail.className += ' m-clone';
      [head, tail].forEach(function(c){
        [].slice.call(c.querySelectorAll('[id]')).forEach(function(e){ e.removeAttribute('id'); });
      });
      track.insertBefore(head, items[0]); track.appendChild(tail);
      function centerOn(el){
        if(!el) return;
        var tr = track.getBoundingClientRect(), er = el.getBoundingClientRect();
        track.scrollTo({ left: track.scrollLeft + (er.left - tr.left) - (track.clientWidth - er.width) / 2, behavior:'instant' });
      }
      function pitch(){ var c = track.children[1]; return c ? (c.getBoundingClientRect().width + 14) : 1; }
      function idx(){ return Math.round(track.scrollLeft / pitch()); }
      requestAnimationFrame(function(){ centerOn(track.children[1]); });
      track.addEventListener('scrollend', function(){
        var a = idx();
        if(a <= 0) centerOn(track.children[n]);
        else if(a >= n + 1) centerOn(track.children[1]);
      });
    });
  }

  /* ---------- flip cards (hover desktop via CSS + tap/keyboard here) ---------- */
  function flips(){
    document.querySelectorAll('.wi-d2 .flip').forEach(function(f){
      f.addEventListener('click', function(){ f.classList.toggle('flipped'); });
      f.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); f.classList.toggle('flipped'); }
      });
    });
  }

  /* ---------- before/after drag sliders (desktop; mobile pairs are static via CSS) ---------- */
  function baSliders(){
    document.querySelectorAll('.wi-d2 .ba-slider').forEach(function(s){
      var before = s.querySelector('.ba-before'), handle = s.querySelector('.ba-handle');
      if(!before || !handle) return;
      function set(px){
        var r = s.getBoundingClientRect();
        var p = Math.max(0, Math.min(1, (px - r.left) / r.width));
        before.style.clipPath = 'inset(0 ' + ((1 - p) * 100) + '% 0 0)';
        handle.style.left = (p * 100) + '%';
      }
      var drag = false;
      s.addEventListener('pointerdown', function(e){ drag = true; set(e.clientX); });
      window.addEventListener('pointermove', function(e){ if(drag) set(e.clientX); });
      window.addEventListener('pointerup', function(){ drag = false; });
    });
  }

  /* ---------- page FAQ accordions ---------- */
  function faqs(){
    document.querySelectorAll('.wi-d2 .faq-q').forEach(function(q){
      q.onclick = function(){
        var a = q.nextElementSibling;
        if(!a) return;
        var open = a.style.maxHeight && a.style.maxHeight !== '0px';
        a.style.maxHeight = open ? '0px' : a.scrollHeight + 'px';
        var pm = q.querySelector('.pm');
        if(pm) pm.textContent = open ? '+' : '–';
      };
    });
  }

  /* ---------- qty steppers + generic price ----------
     Unit price is read (fresh, per call) from #atcMain data-unit-price as a decimal
     dollars string (e.g. "79.00"). window._updPrice is defined normally: variant and
     toggle pages load AFTER this file and intentionally overwrite it. All lookups are
     null-checked so a page missing #atcMain / #atcPrice / a stepper never throws. */
  function steppers(){
    /* On the theme this file is DEFERRED while page-local money scripts (size variants,
       purchase toggle) run inline BEFORE it: never clobber their _updPrice. */
    if(!window._updPrice) window._updPrice = function(){
      var qEl = document.getElementById('qVal');
      var main = document.getElementById('atcMain');
      var priceEl = document.getElementById('atcPrice');
      if(!qEl || !main || !priceEl) return;
      var unit = parseFloat(main.dataset.unitPrice);
      if(isNaN(unit)) return;
      var q = Math.max(1, parseInt(qEl.value, 10) || 1);
      priceEl.textContent = '$' + (unit * q).toFixed(2);
    };
    function bind(minusId, valId, plusId){
      var v = document.getElementById(valId);
      if(!v) return;
      var minus = document.getElementById(minusId), plus = document.getElementById(plusId);
      if(minus) minus.onclick = function(){ v.value = Math.max(1, (parseInt(v.value, 10) || 1) - 1); window._updPrice(); };
      if(plus) plus.onclick = function(){ v.value = (parseInt(v.value, 10) || 1) + 1; window._updPrice(); };
    }
    bind('qMinus', 'qVal', 'qPlus');   // hero stepper (drives #atcPrice)
    bind('sqMinus', 'sqVal', 'sqPlus'); // sticky-bar stepper
  }

  /* ---------- mobile pdesc clamp + Read more (7/21) ----------
     Clamp + toggle only when the paragraph overflows. resize fallback covers emulated
     viewports where matchMedia 'change' never fires; userOpened guard so a rotation or
     URL-bar resize never re-collapses an expanded paragraph. */
  function pdescClamp(){
    var p = document.querySelector('.wi-d2 .pdesc');
    if(!p) return;
    var mq = window.matchMedia('(max-width:600px)');
    var userOpened = false;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'pdesc-more'; btn.textContent = 'Read more';
    p.insertAdjacentElement('afterend', btn);
    function sync(){
      if(!mq.matches){ p.classList.remove('clamped'); btn.classList.remove('show'); return; }
      if(userOpened){ btn.classList.add('show'); return; }
      p.classList.add('clamped');
      if(p.scrollHeight > p.clientHeight + 2){ btn.classList.add('show'); }
      else { p.classList.remove('clamped'); btn.classList.remove('show'); }
    }
    btn.onclick = function(){
      if(p.classList.contains('clamped')){ p.classList.remove('clamped'); btn.textContent = 'Read less'; userOpened = true; }
      else { p.classList.add('clamped'); btn.textContent = 'Read more'; userOpened = false; }
    };
    if(mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
    window.addEventListener('resize', sync, { passive:true });
    sync();
  }

  /* ---------- sticky ATC visibility (show when the buy row is out of view either way) ---------- */
  function stickyBar(){
    var bar = document.getElementById('stickyAtc');
    var hero = document.querySelector('.wi-d2 .qty-cta');
    if(!bar || !hero) return;
    function sync(){
      var r = hero.getBoundingClientRect();
      bar.classList.toggle('show', r.bottom < 0 || r.top > window.innerHeight);
    }
    window.addEventListener('scroll', sync, { passive:true });
    sync();
  }

  /* ---------- sticky ATC submits the real product form ----------
     Sync the sticky qty into #qVal, recompute the hero price, then submit the live
     <form id="wi-d-product-form">. No mock overlay: the live theme owns the cart. */
  function stickySubmit(){
    var btn = document.getElementById('atcSticky');
    if(!btn) return;
    btn.addEventListener('click', function(){
      var sq = document.getElementById('sqVal'), q = document.getElementById('qVal');
      if(sq && q && sq.offsetParent !== null){
        q.value = Math.max(1, parseInt(sq.value, 10) || 1);
      }
      if(window._updPrice) window._updPrice();
      var form = document.getElementById('wi-d-product-form');
      if(!form){
        /* bundle pages have no product form: delegate the sticky click to whichever
           main CTA the purchase toggle is showing (7/26: subscribe anchor into the
           build-a-box page, or the one-time duo-add button) */
        var ot = document.getElementById('atcOnetime');
        var a = document.getElementById('atcMain');
        var target = (ot && ot.offsetParent !== null) ? ot : a;
        if(target) target.click();
        return;
      }
      if(form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }

  /* ---------- duo-add: one-time AJAX add to cart ----------
     Each .duo-add reads data-variant-id. No id -> the button stays inert. With one,
     a click POSTs a single unit to /cart/add.js, flips the label to Added, and re-renders
     the theme's cart drawer so it flies out.
     7/21 evening (owner item 2): Be Yours is NOT Dawn — there is no cart-drawer section.
     Its contract (assets/cart-drawer.js + ProductForm in global.js) is: request sections
     'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble' with the add, then call
     document.querySelector('mini-cart').renderContents(parsedState), which repaints those
     sections and opens the drawer. Failures restore the button and warn once. */
  function duoAdd(){
    var warned = false;
    var btns = document.querySelectorAll('.wi-d2 .duo-add');
    if(!btns.length) return;
    [].forEach.call(btns, function(btn){
      var vid = btn.dataset.variantId;
      if(!vid) return; // no variant id: leave the button inert
      btn.addEventListener('click', function(){
        if(btn.disabled) return;
        var original = btn.innerHTML;
        btn.disabled = true;
        var mini = document.querySelector('mini-cart');
        var sectionIds = (mini && typeof mini.getSectionsToRender === 'function')
          ? mini.getSectionsToRender().map(function(s){ return s.id; })
          : ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
        try{
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }], sections: sectionIds.join(','), sections_url: window.location.pathname })
          }).then(function(res){
            if(!res.ok) throw new Error('add failed');
            return res.json();
          }).then(function(parsedState){
            if(parsedState && parsedState.status) throw new Error(parsedState.description || 'add rejected');
            btn.textContent = 'Added ✓';
            try{
              if(mini && typeof mini.renderContents === 'function' && parsedState && parsedState.sections){
                mini.renderContents(parsedState);   // Be Yours contract: repaints + opens the drawer
              }
            }catch(_){ }
            setTimeout(function(){ btn.innerHTML = original; btn.disabled = false; }, 2500);
          }).catch(function(){
            btn.innerHTML = original; btn.disabled = false;
            if(!warned){ warned = true; try{ console.warn('wi-d2: duo-add to cart failed'); }catch(_){ } }
          });
        }catch(err){
          btn.innerHTML = original; btn.disabled = false;
          if(!warned){ warned = true; try{ console.warn('wi-d2: duo-add to cart failed'); }catch(_){ } }
        }
      });
    });
  }

  /* ---------- 237:1 count-up + bars ---------- */
  function statBand(){
    var stat = document.getElementById('stat');
    if(!stat) return;
    var num = document.getElementById('ratioNum');
    var bars = stat.querySelectorAll('.dd-bar');
    var played = false;
    function play(){
      bars.forEach(function(b){
        b.style.transition = 'none'; b.style.width = '0';
        void b.offsetWidth;                 // force reflow so 0 paints before transitioning
        b.style.transition = 'width 1.1s ease'; b.style.width = b.dataset.w + '%';
      });
      if(!num) return;
      var target = 237, start = Date.now(), dur = 1400;
      var iv = setInterval(function(){
        var pr = Math.min(1, (Date.now() - start) / dur);
        num.textContent = Math.round(target * (0.15 + 0.85 * pr * pr));
        if(pr >= 1){ num.textContent = 237; clearInterval(iv); }
      }, 30);
    }
    var replay = document.getElementById('replayBtn');
    if(replay) replay.onclick = play;
    function fire(){ if(!played){ played = true; play(); } }
    if(typeof IntersectionObserver !== 'undefined'){
      var io = new IntersectionObserver(function(en){
        en.forEach(function(e){ if(e.isIntersecting) fire(); });
      }, { threshold:.4 });
      io.observe(stat);
    }
    /* scroll fallback: IO delivery proved unreliable in some embedded/preview contexts, and a
       missed trigger leaves the band dead. Cheap rect check on scroll, self-removing. */
    function check(){
      if(played){ window.removeEventListener('scroll', check); return; }
      var r = stat.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if(visible > Math.min(r.height, vh) * 0.4){ window.removeEventListener('scroll', check); fire(); }
    }
    window.addEventListener('scroll', check, { passive:true });
    check();
  }

  /* ---------- triptych degree-day count-up (seeded on load, replays once on scroll) ---------- */
  function triptychCounter(){
    var band = document.getElementById('triptych');
    var el = document.getElementById('triCount');
    if(!band || !el) return;
    var target = 1956, played = false;   // 1,146 + 432 + 378 = 1,956 degree-days
    el.textContent = target.toLocaleString();   // seed so a non-scrolled view is never blank
    function play(){
      var start = Date.now(), dur = 1600;
      var iv = setInterval(function(){
        var pr = Math.min(1, (Date.now() - start) / dur);
        el.textContent = Math.round(target * (pr * (2 - pr))).toLocaleString();   // ease-out
        if(pr >= 1){ el.textContent = target.toLocaleString(); clearInterval(iv); }
      }, 28);
    }
    if(typeof IntersectionObserver === 'undefined') return; // seed value already shown
    var io = new IntersectionObserver(function(en){
      en.forEach(function(e){ if(e.isIntersecting && !played){ played = true; play(); } });
    }, { threshold:.35 });
    io.observe(band);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
